<template>
  <div class="upload">
    <div class="product-pic-list">
      <draggable
        :list="info.imgs"
        :disabled="!enabled"
        class="list-group iblock"
        ghost-class="ghost"
        @start="dragging = true"
        @end="draggableEnd()"
      >
        <div class="image l" v-for="(item,index) in info.imgs" :key="index">
          <div class="deal-wrap" v-if="typeof item != 'object'">
            <i class="el-icon-delete deal-item" title="删除" @click="delImg(index)"></i>
            <i class="el-icon-zoom-in deal-item" title="预览" @click="enLarge(item)"></i>
          </div>
          <i class="el-icon-loading" v-if="typeof item == 'object'"></i>
          <img v-else :src="item" alt />
        </div>
      </draggable>
      <el-upload
        class="uploader"
        action="/admin/upload/image"
        accept="image/*"
        :multiple="true"
        name="imageFile"
        :show-file-list="false"
        :before-upload="uploadBannerBefore"
        :on-exceed="uploadBannerExceed"
        :on-error="uploadBannerError"
        :on-success="uploadBannerSuccess"
      >
        <div class="cover">
          <i class="el-icon-plus"></i>
          <span>添加图片</span>
        </div>
      </el-upload>
    </div>

    <el-dialog title="预览" :visible.sync="largeDialogVisible" width="30%">
      <img :src="img_url" width="100%" alt />
    </el-dialog>
  </div>
</template>

<script>
const FILE_LIMIT_SIZE = 6 * 1024 * 1024;

import draggable from "vuedraggable";

export default {
  props: {
    coverPPt: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    coverPPt(val) {
      this.info.imgs = val;
    }
  },
  components: {
    draggable
  },
  data() {
    return {
      info: {
        imgs: []
      },
      enabled: true,
      dragging: false,
      showCropper: false,
      largeDialogVisible: false,
      img_url: ""
    };
  },
  methods: {
     //拖动实时位置和数据
    draggableEnd() {
      this.dragging = false;
      // console.log(this.info.imgs);
    },
    uploadBannerBefore(file) {
      this.info.imgs.push({ uid: file.uid });
    },
    uploadBannerExceed() {
      // this.$message.error("最多只能上传6张产品图片");
    },
    uploadBannerSuccess(response, file, fileList) {
      //图片上传成功后的数据处理
      if (response.success === "false") {
        this.$message.error(response.errorMsg);
        return;
      }
      this.info.imgs.forEach((t, i, arr) => {
        typeof t == "object" &&
          t.uid == file.uid &&
          arr.splice(i, 1, response.result.url);
      });
      this.$emit("uploadPPT", this.info.imgs);
    },
    uploadBannerError() {
      this.$message.error("上传失败");
    },
    delImg(index) {
      this.info.imgs.splice(index, 1);
      this.$emit("uploadPPT", this.info.imgs);
    },
    //预览功能
    enLarge(item) {
      this.img_url = item;
      this.largeDialogVisible = true;
    },
    // 拖动事件触发
    // checkMove(e) {
    //   // console.log(e.draggedContext);
    //   window.console.log("Future index: " + e.draggedContext.futureIndex);
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.product-pic-list {
  display: flex;
  flex-wrap: wrap;
  .image {
    width: 200px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    margin-right: 15px;
    margin-bottom: 15px;
    &:hover {
      .deal-wrap {
        display: flex;
      }
    }
    img {
      width: 100%;
    }
    .deal-wrap {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.3);
      display: none;
      justify-content: center;
      align-items: center;
    }
    .deal-item {
      color: #ffffff;
      font-size: 16px;
      cursor: pointer;
      &:hover {
        color: #369ad1;
      }
      & + .deal-item {
        margin-left: 15px;
      }
    }
  }
}
.uploader {
  margin-bottom: 15px;
}
.cover {
  width: 200px;
  height: 100px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #dcdfe6;
  color: #999999;
  &:hover {
    color: #369ad1;
    border-color: #369ad1;
  }
}
</style>
